export default function Employees({ data }) {
  // ✅ Sort employees by ID ascending (safe copy)
  const sortedEmployees = [...data.employees].sort((a, b) => {
    if (a.id == null || b.id == null) return 0;
    return a.id - b.id;
  });

  return (
    <div className="card">
      <h3>Employees Overview</h3>

      {sortedEmployees.map(emp => {
        const logs = data.logs.filter(l => l.employee_id === emp.id);

        const snaps = data.snapshots
          .filter(s => s.employee_id === emp.id)
          .sort(
            (a, b) =>
              new Date(b.captured_at).getTime() -
              new Date(a.captured_at).getTime()
          );

        return (
          <details key={emp.id} className="card">
            {/* ================= EMPLOYEE HEADER ================= */}
            <summary>
              👤 {emp.employee_name} (ID: {emp.id})
              <div className="small">
                Logs: {logs.length} | Snapshots: {snaps.length}
              </div>
            </summary>

            {/* ================= LOGS SECTION ================= */}
            <details className="inner-section">
              <summary>📄 Logs</summary>

              {logs.length ? (
                <table>
                  <thead>
                    <tr>
                      <th>Level</th>
                      <th>Message</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((l, i) => (
                      <tr key={i}>
                        <td>{l.level}</td>
                        <td>{l.message}</td>
                        <td>{l.created_at}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="small">No logs</p>
              )}
            </details>

            {/* ================= SNAPSHOTS SECTION ================= */}
            <details className="inner-section">
              <summary>🖼️ Snapshots</summary>

              {snaps.length ? (
                <div className="snapshot-grid">
                  {snaps.map((s, i) => {
                    const imgSrc = s.image_url || s.filepath;

                    return (
                      <div key={i} className="snapshot-card">
                        {imgSrc ? (
                          <a href={imgSrc} target="_blank" rel="noreferrer">
                            <img
                              src={imgSrc}
                              alt="snapshot"
                              className="snapshot-img"
                            />
                          </a>
                        ) : (
                          <div className="snapshot-missing">No Image</div>
                        )}

                        <div className="snapshot-time">
                          {new Date(s.captured_at).toLocaleString()}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="small">No snapshots</p>
              )}
            </details>
          </details>
        );
      })}
    </div>
  );
}
